var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "frame-list-box" }, [_c('ul', { staticClass: "frame-list-ul" }, _vm._l(_vm.frames, function (item, index) {
    return _c('li', { key: index, staticClass: "frame-list-li", on: { "click": function click($event) {
          return _vm.changeImg(item);
        } } }, [_c('div', { staticClass: "img-box", class: { 'img-box-active': _vm.currentFrame === item.id } }, [_c('img', { attrs: { "src": item.url, "alt": "" } })])]);
  }), 0)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };